import { useQuery } from "@tanstack/react-query";

import { api } from "../api/rest";
import type { Rebates } from "../api/types";
import { useCommandTarget } from "../store/useAccounts";

/**
 * Такт опроса раздела возврата.
 *
 * Минута, а не тридцать секунд, как у сводов: тир пересчитывается биржей РАЗ В
 * СУТКИ, в 00:00 UTC, и чаще меняется только суточный объём. Опрашивать чаще —
 * значит гонять запрос к базе и кеш ленты выплат ради числа, которое за минуту
 * сдвинется на доли процента.
 *
 * Но и не реже: у порога оператор смотрит на «сколько осталось» в течение дня,
 * и пятиминутное запаздывание сделало бы раздел бесполезным ровно там, где он
 * нужен.
 */
const POLL_MS = 60_000;

export const rebatesKey = ["rebates"] as const;

/**
 * Тир программы возврата тейкерской комиссии и то, чего он стоит.
 *
 * Опрос REST, а не сокет: это СОСТОЯНИЕ («где мы стоим»), а не поток событий, —
 * то же правило, что у свода встреч и панели накопления.
 */
export function useRebates(explicit?: string | null) {
  // Тир и выплаты у каждого аккаунта свои: биржа считает их по кошельку.
  // Аккаунт — выбранный в панели, если вызывающий не назвал свой (карточка
  // аккаунта в таблице); без аккаунта запрос не идёт.
  const target = useCommandTarget();
  const account = explicit === undefined ? target.account : explicit;
  return useQuery<Rebates>({
    queryKey: [...rebatesKey, account ?? ""],
    queryFn: async () => (await api.rebates(account ?? "")).rebates,
    enabled: account !== null,
    refetchInterval: POLL_MS,
    // Прошлый ответ остаётся на экране, пока едет новый: раздел читают глазами,
    // и мигание в прочерк на каждом такте сделало бы его нечитаемым. Но только
    // ответ ТОГО ЖЕ аккаунта: при смене аккаунта (или выборе когорты) тир
    // прежнего, показанный под новым выбором, был бы чужой цифрой.
    placeholderData: (prev, prevQuery) =>
      prevQuery && prevQuery.queryKey[prevQuery.queryKey.length - 1] === (account ?? "") ? prev : undefined,
  });
}
